module.exports = __webpack_public_path__ + "static/media/illus-web.7ecdf7a1.png";